module.exports = __webpack_public_path__ + "media/assets/images/leanbit_home/nosco_interfaccia_home_2-a22a81c4bd54c977650f1a1e7599ccad.png";